import { dateTypes } from '../../../constants/date'
import dayjs from '../../../helpers/dayjs'
import { ecbrRequest } from '../../request/ecbrRequest'

export const adminDashboards = {
  get: async (params) => ecbrRequest.get('/reports/dashboard', { params }),
  getFullPeriod: async ({ endDate }) =>
    ecbrRequest.get('/reports/dashboard', {
      params: {
        start_date: dateTypes.allTimeInit,
        end_date: endDate || dayjs().format(dateTypes.dateTimeISO)
      }
    })
}
